<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.22 16.22">
  <path d="M8.11 6.69L14.513.287a.98.98 0 0 1 1.386 0l.034.034a.98.98 0 0 1 0 1.386L9.53 8.11l6.404 6.403a.98.98 0 0 1 0 1.386l-.034.034a.98.98 0 0 1-1.386 0L8.11 9.53l-6.403 6.404a.98.98 0 0 1-1.386 0L.287 15.9a.98.98 0 0 1 0-1.386L6.691 8.11.287 1.707a.98.98 0 0 1 0-1.386L.321.287a.98.98 0 0 1 1.386 0L8.11 6.691z"/>
</svg>
